"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.PlayerSeasonParamsSchema = exports.PlayerSeasonFieldSchema = void 0;
const zod_1 = require("zod");
const util_1 = require("./util");
const query_1 = require("./query");
const playerSeason_1 = require("./playerSeason");
exports.PlayerSeasonFieldSchema = zod_1.z.union((0, util_1.schemaKeys)(playerSeason_1.PlayerSeasonSchema));
exports.PlayerSeasonParamsSchema = (0, query_1.paramsSchema)(exports.PlayerSeasonFieldSchema);
//# sourceMappingURL=playerSeasonQuery.js.map